import { Link } from "react-router-dom";

const COMPANY_LOGO = "/images/assets/h0kydekd-logo-adjust.png";

const footerLinks = {
  company: [
    { label: "Philosophy", href: "/philosophy" },
    { label: "Business", href: "/business" },
    { label: "Leadership", href: "/leadership" },
  ],
  services: [
    { label: "ミライトマッチ", href: "https://miwrite-match.jp/", external: true },
    { label: "記事監修マッチ", href: "https://kansyuu.miwrite-match.jp/", external: true },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Logo & Company Info */}
          <div className="md:col-span-2">
            <Link to="/" data-testid="footer-logo">
              <img 
                src={COMPANY_LOGO} 
                alt="IT&Plucktice" 
                className="h-10 w-auto mb-6"
              />
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed mb-4">
              ひとつのマッチが、未来に火を灯す。
            </p>
            <address className="not-italic text-sm text-gray-500 leading-relaxed">
              〒151-0053<br />
              東京都渋谷区代々木１丁目３０−１５<br />
              天翔代々木ビル
            </address>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-en text-sm font-semibold text-gray-900 mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-500 hover:text-gray-900 transition-colors duration-200"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-en text-sm font-semibold text-gray-900 mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-gray-500 hover:text-gray-900 transition-colors duration-200"
                    data-testid={`footer-link-${link.label}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            お問い合わせ・ご相談はこちらから
          </p>
          <Link
            to="/contact"
            className="bg-black text-white hover:bg-gray-800 rounded-full px-6 py-2.5 text-sm font-medium transition-all duration-300"
            data-testid="footer-contact-button"
          >
            Contact Us
          </Link>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-xs text-gray-400 text-center font-en">
            © {new Date().getFullYear()} IT&Plucktice Corp. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
